import { motion } from 'framer-motion';
import SEO from '@/components/SEO';

export default function Terms() {
  return (
    <div data-testid="terms-page">
      <SEO page="terms" />
      {/* Hero */}
      <section className="pt-32 pb-12 bg-slate-900">
        <div className="max-w-4xl mx-auto px-6 md:px-12">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
          >
            <h1 className="font-heading text-4xl sm:text-5xl font-bold text-white uppercase mb-4">
              Terms of Service
            </h1>
            <p className="text-slate-400">Last updated: January 2026</p>
          </motion.div>
        </div>
      </section>

      {/* Content */}
      <section className="py-16 md:py-24 bg-white">
        <div className="max-w-4xl mx-auto px-6 md:px-12">
          <div className="prose prose-slate max-w-none">
            <h2 className="font-heading text-2xl font-bold text-slate-900 uppercase mb-4">Agreement to Terms</h2>
            <p className="text-slate-600 mb-6">
              By accessing and using the Vulcan Recruitment website and services, you agree to be bound by these Terms of Service. If you do not agree to these terms, please do not use our services.
            </p>

            <h2 className="font-heading text-2xl font-bold text-slate-900 uppercase mb-4 mt-10">Our Services</h2>
            <p className="text-slate-600 mb-6">
              Vulcan Recruitment provides recruitment and employment services connecting employers with job seekers in the construction, engineering, trades, and industrial sectors. Our services include candidate sourcing, screening, and placement assistance.
            </p>

            <h2 className="font-heading text-2xl font-bold text-slate-900 uppercase mb-4 mt-10">User Responsibilities</h2>
            <p className="text-slate-600 mb-4">When using our services, you agree to:</p>
            <ul className="list-disc pl-6 text-slate-600 space-y-2 mb-6">
              <li>Provide accurate and truthful information</li>
              <li>Keep your contact details up to date</li>
              <li>Not misrepresent your qualifications or experience</li>
              <li>Not use our services for any unlawful purpose</li>
              <li>Respect the confidentiality of information shared with you</li>
            </ul>

            <h2 className="font-heading text-2xl font-bold text-slate-900 uppercase mb-4 mt-10">For Employers</h2>
            <p className="text-slate-600 mb-6">
              Employers using our services agree to provide accurate job descriptions and requirements, comply with all applicable employment laws, and maintain confidentiality of candidate information. Recruitment fees and terms will be agreed separately in writing.
            </p>

            <h2 className="font-heading text-2xl font-bold text-slate-900 uppercase mb-4 mt-10">For Candidates</h2>
            <p className="text-slate-600 mb-6">
              Candidates using our services agree to provide accurate information about their qualifications, experience, and availability. Candidates should notify us promptly if they accept employment or are no longer seeking work.
            </p>

            <h2 className="font-heading text-2xl font-bold text-slate-900 uppercase mb-4 mt-10">Limitation of Liability</h2>
            <p className="text-slate-600 mb-6">
              Vulcan Recruitment acts as an intermediary between employers and candidates. We do not guarantee employment outcomes and are not liable for any decisions made by employers or candidates. We make no warranties about the accuracy of information provided by third parties.
            </p>

            <h2 className="font-heading text-2xl font-bold text-slate-900 uppercase mb-4 mt-10">Intellectual Property</h2>
            <p className="text-slate-600 mb-6">
              All content on this website, including text, graphics, logos, and images, is the property of Vulcan Recruitment and is protected by copyright laws. You may not reproduce, distribute, or use our content without written permission.
            </p>

            <h2 className="font-heading text-2xl font-bold text-slate-900 uppercase mb-4 mt-10">Changes to Terms</h2>
            <p className="text-slate-600 mb-6">
              We may update these terms from time to time. Continued use of our services after changes constitutes acceptance of the modified terms. We encourage you to review these terms periodically.
            </p>

            <h2 className="font-heading text-2xl font-bold text-slate-900 uppercase mb-4 mt-10">Governing Law</h2>
            <p className="text-slate-600 mb-6">
              These terms are governed by the laws of Victoria, Australia. Any disputes arising from these terms or our services will be subject to the jurisdiction of the courts of Victoria.
            </p>

            <h2 className="font-heading text-2xl font-bold text-slate-900 uppercase mb-4 mt-10">Contact</h2>
            <p className="text-slate-600 mb-6">
              For questions about these terms, please contact us:
            </p>
            <div className="bg-slate-50 p-6 border border-slate-200">
              <p className="text-slate-700 font-semibold">Vulcan Recruitment</p>
              <p className="text-slate-600">Email: info@vulcanrecruitment.com</p>
              <p className="text-slate-600">Phone: +61 469 362 319</p>
              <p className="text-slate-600">Location: Thomastown, Victoria, Australia</p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
